import { NgModule } from '@angular/core';
import { HttpVerbsEnum } from '../shared/enums/http-verbs.enum';
import { StorySubject } from '../story/model/story-subject.model';
import { Observable } from 'rxjs';
import { SelectItem } from 'primeng/api';
import { NeptuneApi } from '../genericApi/neptune.api';

@NgModule({
    providers: []
})

export class SubjectApi {
    public subjectList: SelectItem[] = [];

    constructor(
        private neptuneApi: NeptuneApi
    ) {}

    public getSubjectListAPI(): Observable<StorySubject[]>  {
        return this.neptuneApi.api<StorySubject[]>(
            '/subjects',
            {},
            HttpVerbsEnum.GET
        );
    }
}
